<template lang="pug">
  div#app
    //- Header(:title="$route.name" centered @click="reroute()")
    router-view
</template>

<script>
import { mapGetters } from 'vuex';
import { Header } from '@ovo/ravier-vue';
import JSBridge  from '@/helpers/jsbridge';

export default {
  components: {
    Header,
  },
  data() {
    return {
      transitionName: '',
    };
  },  
  computed: {
    ...mapGetters({
      promoDetail: 'getPromoDetail',
    }),
  },
  watch: {
    $route(to, from) {
      document.title = this.$route.name;
      this.transitionName = to.path === '/detail' ? 'slide-left' : 'slide-right';
    },
  },
  beforeMount() {
    document.title = this.$route.name;
    const vueInstance = this;
    window.onReceiveBackEvent = function() {
      vueInstance.reroute();
    };
  },
  methods: {
    reroute() {
      const jsBridge = new JSBridge();

      if (this.$route.path === '/' || this.$route.query.index === 'true') {
        if (document.referrer) {
          this.$router.go(-1);
        } else {
          jsBridge.closeWebView();
        }
      } else {
        if (this.$route.path === '/detail') {
          const promo = {
            Promo_ID: this.promoDetail.id,
            Promo_Name: this.promoDetail.title,
          };
          jsBridge.leanplumWebviewTracker('event/promo_page/exit_promo', promo);
        }

        this.$router.go(-1);
      }
    },
  },
};
</script>
